import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFpxControlComponent } from '@fpx/core';


@Component({
  selector: 'input-number',
  templateUrl: './input-number.component.html',
  styleUrls: ['./input-number.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputNumberComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputNumberComponent extends BaseFpxControlComponent {
  @Input() maxLength:string;
  @Input() step:string;

  constructor(controlContainer: ControlContainer, changeDetectorRef: ChangeDetectorRef) {
    super(controlContainer, changeDetectorRef);
  }

  protected doPreInit(): void {
    
  }

  writeValue(obj: any): void {
    this.formControl.updateValueAndValidity();
  }

}
